import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import DoctorDetailsForm from "./DoctorDetailsForm";

const DoctorProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    loginUser,
    getDoctorDetails,
    doctorDetails,
    doctorDetailsLoading,
    doctorDetailsError,
  } = useContext(AuthContext);

  useEffect(() => {
    if (doctorDetails === null && loginUser?.id) {
      getDoctorDetails(loginUser.id);
    }
    console.log("Doctor Details:", doctorDetails);
  }, [getDoctorDetails, doctorDetails, loginUser]);

  const handleSuccess = () => {
    // Refresh doctor data after successful update
    if (loginUser?.id) {
      getDoctorDetails(loginUser.id);
    }
    // You can also show a success message or redirect
  };

  const handleCancel = () => {
    // Navigate back or close modal
    navigate("/dashboard");
  };

  if (doctorDetailsLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading doctor profile...</p>
        </div>
      </div>
    );
  }

  if (doctorDetailsError) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">❌</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Error</h2>
          <p className="text-gray-600 mb-6">{doctorDetailsError}</p>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  // Don't render the form if doctorDetails is not available
  if (!doctorDetails) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600">No doctor details available</p>
          <button
            onClick={() => navigate("/dashboard")}
            className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <DoctorDetailsForm
          doctorId={doctorDetails._id}
          initialDoctorData={doctorDetails}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default DoctorProfile;
